(function() {
  // Only run on homepage
  if (document.body.dataset.template !== 'index') return;

  const headerLogo = document.querySelector('.header-logo');
  if (!headerLogo) return;

  const hero = document.querySelector('.hero-wrapper');
  if (!hero) return;

  function updateLogoVisibility() {
    const scrollY = window.scrollY || window.pageYOffset;
    const heroRect = hero.getBoundingClientRect();
    const heroTop = heroRect.top + scrollY;
    const heroHeight = heroRect.height;
    const heroMiddle = heroTop + (heroHeight / 2);

    if (scrollY >= heroMiddle) {
      headerLogo.classList.remove('hide-until-scroll');
      headerLogo.classList.add('show-after-scroll');
    } else {
      headerLogo.classList.add('hide-until-scroll');
      headerLogo.classList.remove('show-after-scroll');
    }
  }

  // Initial state - hide logo
  headerLogo.classList.add('hide-until-scroll');

  // Update on scroll
  window.addEventListener('scroll', updateLogoVisibility);
  
  // Update on resize (hero height might change)
  window.addEventListener('resize', updateLogoVisibility);
  
  // Initial check
  updateLogoVisibility();
})();
